import { useTranslation } from 'react-i18next';
// 1:1 с mcms-front. Два блока с разделителем: «За сегодня» + «Кошельки».
// Стили под header (text-content-inverse-muted на тёмном фоне sidebar).

type ProfitInfoHeaderProps = {
  periodProfitAmount: string;
  userBalanceAmount: string;
};

export const ProfitInfoHeader = ({
  periodProfitAmount,
  userBalanceAmount,
}: ProfitInfoHeaderProps) => {
  const { t } = useTranslation('common');

  return (
    <>
      <div className="border-line-muted flex flex-col items-start justify-center border-r px-6">
        <span className="font-bold text-content-inverse-muted">{periodProfitAmount}</span>
        <span className="text-sm text-content-inverse-accent">{t('profit.today')}</span>
      </div>

      <div className="border-line-muted flex flex-col items-start justify-center border-r px-6">
        <div className="flex items-center gap-2">
          <span className="font-bold text-content-inverse-muted">{userBalanceAmount}</span>
        </div>
        <span className="text-sm text-content-inverse-accent">{t('profit.wallets')}</span>
      </div>
    </>
  );
};
